import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommunityProviderProgramEdit } from 'src/app/community/model/community-provider-program';
import { CommunityProgram } from '../model/community-program';

@Injectable({
  providedIn: 'root'
})
export class CommunityProviderProgramService
{
  constructor(private http: HttpClient)
  {
  }

  /**
   * Delete a Community Provider Program.
   *
   * @param id Community Provider Program id
   */
  public deleteCommunityProviderProgram(id: number): Observable<CommunityProviderProgramEdit>
  {
    return this.http.delete<CommunityProviderProgramEdit>(`/community/provider/program/${id}`);
  }

  /**
   * Get a Community Provider Program by id.
   *
   * @param id Community Provider Program id
   */
  public getCommunityProviderProgramById(id: number): Observable<CommunityProviderProgramEdit>
  {
    return this.http.get<CommunityProviderProgramEdit>(`/community/provider/program/${id}`);
  }

  /**
   * Check if Community Provider Program Name exists to avoid name duplicates
   *
   * @param name Community Provider Program Name
   */
  public existsCommunityProviderProgramName(name: string): Observable<any>
  {
    return this.http.get(`/community/provider/program/exists?name=${name}`);
  }

  /**
   * Save a Community Provider Program.
   *
   * @param data Community Provider Program to persit
   *
   * @param isNew Indicate if this is a new or update
   */
  public saveCommunityProviderProgram(data: any, isNew: boolean, id?: number): Observable<any>
  {
    if (isNew)
    {
      return this.http.post('/community/provider/program', data);
    }
    else
    {
      return this.http.put(`/community/provider/program/${id}`, data);
    }
  }

  /**
   * Check if Community Provider Program is in use
   *
   * @param id Community Provider Program id
   */
  public existsCommunityProviderProgram(id: number): Observable<any>
  {
    return this.http.get(`/community/provider/program/inuse/${id}`);
  }

  /**
   * Get all Community Provider Program.
   */
  public getAllCommunityProviderProgram(): Observable<any>
  {
    return this.http.get<any>('/community/provider/program/all');
  }

  public addUpdateCommunityPrograms(programs: CommunityProgram[], validateOnly: boolean): Observable<any[]>
  {
    return this.http.post<any[]>(`/community/provider/program/batch?validateOnly=${validateOnly}`, programs);
  }

  /**
   * Send Community Provider Program referral.
   *
   * @param data Community Provider Program Referral to send.
   */
  public sendReferrals(data: any): Observable<any>
  {
    return this.http.post<any[]>('/community/provider/program/referrals', data);
  }
}
